import { onPath } from '../utils/path';
import { selectMany, addClass, removeClass, toggleClass } from '../utils/dom-utils';
import * as basicLightbox from 'basiclightbox';
import hljs from 'highlight.js/lib/highlight';
import javascript from 'highlight.js/lib/languages/javascript';

hljs.registerLanguage('javascript', javascript);

onPath('/api/*', () => {

  /*
    Wrap each image from Markdown content in a <figure> element
    Clone the image and its wrapper for use in lightbox
    Invoke lightbox on image click
  */

  const images = selectMany('.article-body img');

  images.forEach(function (el, i) {

    el.addEventListener('click', (evt) => {

      const lightboxImgWrapper = document.createElement('figure');
      const lightboxImg = el.cloneNode(true);
      lightboxImgWrapper.appendChild(lightboxImg);

      const instance = basicLightbox.create(lightboxImgWrapper);
      instance.show();

    });

  });


  /*
    hightlight.js syntax highlighter
    Finds and highlights code inside `<pre><code>` tags
    https://github.com/highlightjs/highlight.js#getting-started
  */

  hljs.initHighlightingOnLoad();

});


onPath('/api', () => {

  document.addEventListener('DOMContentLoaded', function() {

    /*
      Attaches the sidebar to the top of the page when scrolling
    */

    var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    var sidebarMenu = document.getElementById("api-menu-left");
    var apiContent = document.getElementById("api-content");
    var sidebarMenuOffset = sidebarMenu.getBoundingClientRect().top + scrollTop;

    function fixedScroll() {
      if (window.scrollY > sidebarMenuOffset) {
        addClass(sidebarMenu, 'scroll-fixed');
        addClass(apiContent, 'scroll-fixed');
      } else {
        removeClass(sidebarMenu, 'scroll-fixed');
        removeClass(apiContent, 'scroll-fixed');
      }
    };

    /*
      Switches between showing API names or functions in the sidebar
    */

    const apiNames = selectMany('.api-name');
    const apiPaths = selectMany('.api-path');
    const apiToggle = selectMany('.api-toggle')

    apiToggle.forEach(function (el, i) {
      el.addEventListener('click', (evt) => {
        apiNames.forEach(function (apiName, i) {
          toggleClass(apiName, 'toggle-hide');
          toggleClass(apiName, 'toggle-show');
        });
        apiPaths.forEach(function (apiPath, i) {
          toggleClass(apiPath, 'toggle-hide');
          toggleClass(apiPath, 'toggle-show');
        });
      });
    });


    window.addEventListener('scroll', function() {
      fixedScroll();
    });


    fixedScroll();
  }, false);

});
